import React from 'react';
import { Box, Button, darken } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { ChildrenProps } from '../interfaces/childrenProps';
import { DialogBoxStyles } from '../styles/dialogBox';

interface DialogProps extends ChildrenProps {
  buttonText: string;
  onSubmit: (event: React.MouseEvent) => void;
}

export const DialogBox = (props: DialogProps): JSX.Element => {
  const { buttonText, onSubmit, children } = props;
  const classes = DialogBoxStyles();

  return (
    <Box
      zIndex="modal"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="fixed"
      width={1}
      color={darken(BrandColors.white, 0.15)}
      bgcolor={BrandColors.blackWithOpacity765}
      className={classes.box}>
      <Box className={classes.innerBox}>{children}</Box>
      <Button onClick={onSubmit} className={classes.button}>
        {buttonText}
      </Button>
    </Box>
  );
};
